// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_3v4-KaSnU2F0BfqcMvqdne"};